export const Check_Small = `<svg title="Check_Small" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Check_small">
<path id="Fill" fill-rule="evenodd" clip-rule="evenodd" d="M17.3647 8.74184L11.5294 16.1193C11.3549 16.34 11.0954 16.4769 10.8147 16.4965C10.534 16.5161 10.2581 16.4165 10.0546 16.2222L6.63525 12.9578L8.01632 11.5112L10.6417 14.0177L15.7961 7.50111L17.3647 8.74184Z" fill="currentcolor"/>
</g>
</svg>
`;